import { FilterMatchMode } from "primereact/api"

export class Consecuencia {
    model = {
        id: { value: null, export: false },
        orden: { value: 1, export: false, header: 'Orden', required: 'Campo requerido', minLength: 'Mínimo 1', max: 5, min: 1, maxLength: 'Máximo 5', table: true },
        nivel: {
            value: '', export: true, header: 'Nivel', required: 'Campo requerido', maxLength: 'Máximo 100 caracteres',
            filterPlaceholder: 'nivel', minLength: 'Mínimo 34caracteres', max: 100, min: 4, filterField: 'descripcion',
            matchMode: FilterMatchMode.CONTAINS,
            table: true
        },
        descripcion: {
            value: '', export: false, header: 'Descripción', required: false, maxLength: 'Máximo 1000 caracteres',
            filterPlaceholder: 'descripcion', minLength: 'Mínimo 4 caracteres', max: 1000, min: 4, filterField: 'descripcion', table: true
        },
    }

    optionLabel = 'tipo_adjunto'
}
